import { useNavigate } from "@tanstack/react-router";
import { useAuthContext } from "@/providers/authProvider/authContext";
import useGeneration from "@/views/generation/hooks/useGeneration";
import { StyledButton } from "./GenerateButton.styles";

const GenerateButton = () => {
  const { handleGenerate } = useGeneration();
  const { user } = useAuthContext();
  const navigate = useNavigate();

  const handleClick = () => {
    if (!user) {
      navigate({ to: "/login" });
      return;
    }

    handleGenerate();
  };

  const getText = () => {
    if (!user) {
      return "登入後開始生成";
    }

    return "開始生成";
  };

  return (
    <StyledButton onClick={handleClick} variant="contained">
      {getText()}
    </StyledButton>
  );
};

export default GenerateButton;
